module.exports = __webpack_public_path__ + "img/features-background-kid.71bd944d.png";